import React from 'react';
import { Layout } from 'antd';
import Sidebar from '../components/Layout/Sidebar/index.tsx';
import { HeaderLayout } from '../components/Layout/Header';
import { Outlet } from 'react-router-dom';
import ResponsiveSidebar from '../components/Layout/Sidebar/ResponsiveSidebar.tsx';
import {
  setSidebarCollapseFlag,
  usePublicState,
} from '../store/slices/publicSlice.ts';
import { useDispatch } from 'react-redux';

const { Content } = Layout;
const DefaultLayout = () => {
  const dispatch = useDispatch();
  const { isSidebarCollapsed } = usePublicState();

  const setCollapsedSidebar = (flag: boolean) =>
    dispatch(setSidebarCollapseFlag(flag));

  return (
    <Layout className="bg-[#F3F4F6]">
      <Sidebar
        collapsed={isSidebarCollapsed}
        onCollapse={setCollapsedSidebar}
      />

      <Layout>
        <HeaderLayout
          collapsed={isSidebarCollapsed}
          onCollapse={setCollapsedSidebar}
        />

        <Content className="p-6">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default DefaultLayout;
